import { Outcome } from "./Outcome";

export function NotFound() {
  return (
    <Outcome chip="404" chipTone="red" title="That page is not here.">
      <p>
        The link may be old, or it may be a typo. The home page has everything
        this site does.
      </p>
    </Outcome>
  );
}
